import { render, staticRenderFns } from "./OrganisationSelfRegistrationAdd.vue?vue&type=template&id=82171ffc&"
import script from "./OrganisationSelfRegistrationAdd.vue?vue&type=script&lang=ts&"
export * from "./OrganisationSelfRegistrationAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82171ffc')) {
      api.createRecord('82171ffc', component.options)
    } else {
      api.reload('82171ffc', component.options)
    }
    module.hot.accept("./OrganisationSelfRegistrationAdd.vue?vue&type=template&id=82171ffc&", function () {
      api.rerender('82171ffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organisations/OrganisationSelfRegistrationAdd.vue"
export default component.exports